export const MIN_WIDTH = 250;
export const DEFAULT_WIDTH = 840;
export const MIN_HEIGHT = 150;
export const DEFAULT_HEIGHT = 500;
export const VIEWPORT_VERTICAL_MARGIN = 40;
export const POPUP_BOUNDARY_CLASS = 'popup-boundary';
export const POPUP_MINIMIZED_WIDTH_SIZE = {
  small: 445,
  middle: 670,
  big: 1346,
};
